import { render, staticRenderFns } from "./OrganisationHomePage.vue?vue&type=template&id=6f6b5ca8&scoped=true"
import script from "./OrganisationHomePage.vue?vue&type=script&lang=js"
export * from "./OrganisationHomePage.vue?vue&type=script&lang=js"
import style0 from "./OrganisationHomePage.vue?vue&type=style&index=0&id=6f6b5ca8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b5ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6b5ca8')) {
      api.createRecord('6f6b5ca8', component.options)
    } else {
      api.reload('6f6b5ca8', component.options)
    }
    module.hot.accept("./OrganisationHomePage.vue?vue&type=template&id=6f6b5ca8&scoped=true", function () {
      api.rerender('6f6b5ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/OrganisationHomePage.vue"
export default component.exports